import { withGTM } from '@/features/shared/HOCs';
import {
  resolveColorName,
  resolveContentBlocks,
  resolveSpacingSize,
  resolveTheme,
} from '@/utils/resolvers';
import React, { useMemo, useRef } from 'react';
import CMSWrapper from '../shared/CMSWrapper';
import ImageGallery from './ImageGallery';
import { mapTarget, onDatalayer } from './ImageGallery.datalayer';

const MappedImageGallery = ({ content, presentation, contentButtons, labels }: any) => {
  const { topSpacing, bottomSpacing, containerTopBackgroundColor, containerBottomBackgroundColor } =
    presentation;
  const containerProps = useMemo(
    () => ({
      topSpacing,
      bottomSpacing,
      topBackgroundColor: containerTopBackgroundColor,
      bottomBackgroundColor: containerBottomBackgroundColor,
    }),
    [bottomSpacing, containerBottomBackgroundColor, containerTopBackgroundColor, topSpacing],
  );
  const theme = useMemo(
    () => resolveTheme('bg-color')({ rawVal: containerTopBackgroundColor }),
    [containerTopBackgroundColor],
  );

  return (
    <div data-datalayer-position="image_gallery">
      <ImageGallery
        content={content}
        containerProps={containerProps}
        theme={theme}
        labels={labels}
        contentButtons={contentButtons}
      />
    </div>
  );
};

const ImageGalleryCMSWrapper = (brProps: any) => {
  const mapping = useRef({
    document: [
      'content',
      {
        listSuperheading: null,
        listTitle: null,
        contentList: [null, resolveContentBlocks],
      },
    ],
    componentParameterMap: [
      'presentation',
      {
        'container-top-background-color': ['containerTopBackgroundColor', resolveColorName],
        'container-bottom-background-color': ['containerBottomBackgroundColor', resolveColorName],
        'top-spacing': ['topSpacing', resolveSpacingSize],
        'bottom-spacing': ['bottomSpacing', resolveSpacingSize],
        'variant-label': 'datalayerVariant',
      },
    ],
    'imageGalleryComponent.labels': 'labels',
  });

  const requiredFields = useRef({
    document: '<b>Content</b> required',
  });

  const contentButtonNames = useRef({
    document: 'content',
  });

  const MappedImageGalleryGTM = withGTM({
    Component: MappedImageGallery,
    onDatalayer,
    config: { mapTarget },
  });

  return (
    <CMSWrapper
      brProps={brProps}
      render={MappedImageGalleryGTM}
      mapping={mapping.current}
      requiredFields={requiredFields.current}
      contentButtonNames={contentButtonNames.current}
    />
  );
};

export default ImageGalleryCMSWrapper;
